import styled from '@emotion/styled';
import { HEADER_HEIGHT } from 'components/navigation/header.constants';
import { SmallText } from 'ds/components/typography';


export const Wrapper = styled.div`
  padding: 0 ${({ theme }) => theme.spacing(3)};
  height: ${HEADER_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  box-shadow: inset 0px -1px 0px ${({ theme }) => theme.colors.neutrals.grey8};
  position: fixed;
  top: ${HEADER_HEIGHT}px;
  width: 100%;
  left: 0;
  z-index: 13;
`;

export const ContentWrapper = styled.div`
  padding-top: ${HEADER_HEIGHT}px;
`;

export const HiddenWrapper = styled.div<{ isVisible: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  opacity: ${({ isVisible }) => isVisible ? 1 : 0};
  user-select: ${({ isVisible }) => isVisible ? 'initial' : 'none'};
  pointer-events: ${({ isVisible }) => isVisible ? 'initial' : 'none'};
  transition: opacity 0.1s linear;
  z-index: 1;
`;

export const BtnWrapper = styled.div`
  position: absolute;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);
`;

export const ContactSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const PhoneButton = styled(SmallText.withComponent('a'))`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-decoration: none;
  display: flex;
  align-items: center;
  svg {
    margin-right: ${({ theme }) => theme.spacing(0.5)};
    path {
      fill: ${({ theme }) => theme.colors.neutrals.grey1};
    }
  }
`;

export const Breadcrumbs = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  > a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.neutrals.grey2};
    &:hover {
      color: ${({ theme }) => theme.colors.brand.main};
    }
  }
`;

export const TextBetween = styled(SmallText)`
   color: ${({ theme }) => theme.colors.neutrals.grey2};
`;
